import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthLayout, AuthDivider, GoogleButton, PasswordField, inputClass } from "@/components/AuthLayout";
import { apiFetch, setToken } from "@/api";

const EMAIL_RE = /^\S+@\S+\.\S+$/;

const Login = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = {};
    const email = form.email.trim();
    if (!email) {
      errs.email = "Enter your email address";
    } else if (!EMAIL_RE.test(email)) {
      errs.email = "Enter a valid email address";
    }
    if (!form.password) errs.password = "Please enter your password";
    setErrors(errs);
    if (Object.keys(errs).length > 0) return;
    try {
      const data = await apiFetch("/login", {
        method: "POST",
        body: { email, password: form.password },
      });
      setToken(data.token);
      navigate(data.user?.board ? "/dashboard" : "/practice-setup");
    } catch (err) {
      setErrors({ password: err.message });
    }
  };

  return (
    <AuthLayout
      title="Welcome back"
      subtitle="Log in to keep your streak going."
      footer={
        <>
          New to Abhyas?{" "}
          <Link
            to="/signup"
            data-testid="goto-signup-link"
            className="font-bold text-[#16A34A] hover:underline"
          >
            Sign up
          </Link>
        </>
      }
    >
      <form data-testid="login-form" onSubmit={handleSubmit} className="space-y-4" noValidate>
        <div>
          <label className="mb-1.5 block text-sm font-bold text-[#17201A]">
            Email
          </label>
          <input
            data-testid="login-email-input"
            type="email"
            value={form.email}
            onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
            placeholder="you@example.com"
            className={inputClass}
          />
          {errors.email && (
            <p data-testid="login-email-error" className="mt-1.5 text-xs font-semibold text-red-500">
              {errors.email}
            </p>
          )}
        </div>
        <div>
          <PasswordField
            label="Password"
            testid="login-password-input"
            value={form.password}
            onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
            placeholder="Your password"
            error={errors.password}
          />
          <div className="mt-2 text-right">
            <Link
              to="/forgot-password"
              data-testid="forgot-password-link"
              className="text-xs font-semibold text-[#16A34A] hover:underline"
            >
              Forgot password?
            </Link>
          </div>
        </div>
        <button
          type="submit"
          data-testid="login-submit-btn"
          data-magnetic="true"
          className="w-full rounded-full bg-[#16A34A] py-4 text-base font-bold text-white shadow-sm transition-[background-color,transform] duration-200 hover:bg-[#15803D]"
        >
          Login
        </button>
        <AuthDivider />
        <GoogleButton />
      </form>
    </AuthLayout>
  );
};

export default Login;
